'use client';

import { useEffect, useState } from 'react';
import invariant from 'tiny-invariant';

import { getNextApiRoute, typedFetch } from '@libs/common-next';

/**
 * Hook to initialize OneTrust parameters.
 * Here we generate JWT and form a string to be inserted into the script.
 * All code is executed on the client, after rendering.
 */
export const useOneTrustParams = ({ customerKey }: { customerKey: string | undefined }) => {
    const [newToken, setNewToken] = useState<string>('');

    useEffect(() => {
        const fetchOneTrustScript = async () => {
            if (!customerKey) {
                return;
            }

            const response = await typedFetch<{
                success: boolean;
                message: string;
                token?: string;
            }>(getNextApiRoute(`onetrust/generate-token/${customerKey}`));

            invariant(response?.token, `RequestNewToken failed: ${response?.message}`);
            setNewToken(response.token);
        };

        fetchOneTrustScript();
    }, [customerKey]);

    return { token: newToken };
};
